import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Row,
  Col,
  Modal,
  Checkbox,
  Tooltip,
} from "antd";
import get from "lodash/get";
import without from "lodash/without";
import { connect } from "react-redux";
import classnames from "classnames";

import {
  updateRoleRequest,
  createRoleRequest,
  toggleActivateRoleRequest,
} from "../../api/requests";
import {
  getRoleCreatePermission,
  getRoleDeletePermission,
  getRoleUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./SettingsRoleForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class SettingsRoleForm extends React.Component {
  constructor(props) {
    super(props);

    const openGroups = {};
    const fieldKeys = Object.keys(this.props.permissionsStructure);
    fieldKeys.forEach((key) => {
      openGroups[key] = true;
    });

    this.state = {
      isLoading: false,
      requestResult: {},
      deactivateSubmitModal: false,
      roleState: "",
      openGroups,
    };
    
    console.log(this.props.permissionsStructure);
  }

  componentDidMount() {
    this.setState({ roleState: this.props.state });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const roleRaw = { ...values };
          delete roleRaw.name;
          delete roleRaw.description;
          let roles = [];

          Object.keys(roleRaw).forEach((roleKey) => {
            if (Array.isArray(roleRaw[roleKey])) {
              roleRaw[roleKey].forEach((rolePermission) => {
                roles.push(+rolePermission);
              });
            } else {
              if (roleRaw[roleKey]) {
                roles.push(+roleKey);
              }
            }
          });

          if (this.props.id) {
            await updateRoleRequest(this.props.id, {
              name: values.name,
              description: values.description,
              permissions: roles,
            });
          } else {
            await createRoleRequest({
              name: values.name,
              description: values.description,
              permissions: roles,
            });
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });
        }
      }
    });
  };

  showDeactivateModal = () => {
    this.setState({ deactivateSubmitModal: true });
  };
  hideDeactivateModal = () => {
    this.setState({ deactivateSubmitModal: false });
  };

  toggleActivate = async () => {
    try {
      await toggleActivateRoleRequest(this.props.id, this.state.roleState);
      this.setState({
        requestResult: {
          type: "success",
          message: this.props.i18n.t("Success"),
        },
        roleState: this.state.roleState === "inactive" ? "active" : "inactive",
      });
      this.hideDeactivateModal();
      setTimeout(() => {
        this.props.onSubmit(this.props.id);
      }, 1000);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  onCheckAllChange = (fieldGroup, isCheckedAll) => () => {
    this.props.permissionsStructure[fieldGroup].fields.forEach((field) => {
      if (!field.permissions) {
        this.props.form.setFieldsValue({ [field.key]: !isCheckedAll });
      } else {
        this.props.form.setFieldsValue({
          [field.key]: isCheckedAll
            ? []
            : field.permissions.map((permission) => permission.key),
        });
      }
    });

    this.setFieldsDependency();
  };

  onCheckField = (fieldKey, isCheckedFieldAll, fieldPermissions) => () => {
    this.props.form.setFieldsValue({
      [fieldKey]: isCheckedFieldAll
        ? []
        : fieldPermissions.map((permission) => permission.key),
    });
  };

  collapseSection = (sectionName) => () => {
    this.setState((state) => ({
      openGroups: {
        ...state.openGroups,
        [sectionName]: !state.openGroups[sectionName],
      },
    }));
  };

  onCheckChange = () => {
    this.setFieldsDependency();
  };

  setFieldsDependency = () => {
    setTimeout(() => {
      if (
        !this.props.form.getFieldValue(
          "patient_profile_drug_reallocate_summary"
        )
      ) {
        this.props.form.setFieldsValue({
          notification: without(
            this.props.form.getFieldValue("notification"),
            "profile_drug_reallocate_summary"
          ),
        });
      }
      if (
        !this.props.form.getFieldValue(
          "patient_profile_drug_reallocate_detailed"
        )
      ) {
        this.props.form.setFieldsValue({
          notification: without(
            this.props.form.getFieldValue("notification"),
            "profile_drug_reallocate_detailed"
          ),
        });
      }
    }, 0);
  };

  render() {
    const {
      isLoading,
      requestResult,
      deactivateSubmitModal,
      openGroups,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      roleUpdatePermission,
      roleCreatePermission,
      roleDeletePermission,
      id,
      isNew,
      state,
    } = this.props;

    const isEditable = id ? roleUpdatePermission : roleCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                {state && (
                  <Badge
                    count={state}
                    style={{
                      backgroundColor: state === "active" ? "#49c850" : "#f00",
                    }}
                  />
                )}{" "}
                <Badge
                  count={this.props.i18n.t("Edit")}
                  style={{ backgroundColor: "#2968AE" }}
                />
              </span>
            ) : isNew ? (
              this.props.i18n.t("Add role")
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col sm={12}>
              <label>
                <b>{this.props.i18n.t("Name")}:</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Name")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col sm={12}>
              <label>
                <b>{this.props.i18n.t("Description")}:</b>
                <Form.Item>
                  {getFieldDecorator("description", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "description", ""),
                  })(
                    <Input
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Description")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {this.props.id && roleDeletePermission && (
            <Row gutter={12}>
              <Col>
                <p>
                  <Button
                    type="default"
                    style={{
                      backgroundColor:
                        this.state.roleState === "inactive"
                          ? "#44c721"
                          : "#f56009",
                      borderColor: "#fff",
                      color: "#fff",
                    }}
                    onClick={this.showDeactivateModal}
                  >
                    {this.state.roleState === "inactive"
                      ? this.props.i18n.t("Activate")
                      : this.props.i18n.t("Deactivate")}
                  </Button>
                </p>
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col>
              <h4 className="headline-default">
                {this.props.i18n.t("NamespaceSettingsRoleForm:Role settings")}
              </h4>

              {Object.keys(this.props.permissionsStructure).map(
                (fieldGroupName) => {
                  let isCheckedAll = true;
                  let isNotCheckedAll = true;

                  this.props.permissionsStructure[fieldGroupName].fields.some(
                    (field) => {
                      const value = this.props.form.getFieldValue(field.key);

                      if (Array.isArray(value)) {
                        if (value.length !== field.permissions.length) {
                          isCheckedAll = false;
                          return true;
                        }
                      } else {
                        if (!value) {
                          isCheckedAll = false;
                          return true;
                        }
                      }
                    }
                  );

                  this.props.permissionsStructure[fieldGroupName].fields.some(
                    (field) => {
                      const value = this.props.form.getFieldValue(field.key);

                      if (Array.isArray(value)) {
                        if (value.length > 0) {
                          isNotCheckedAll = false;
                          return true;
                        }
                      } else {
                        if (value) {
                          isNotCheckedAll = false;
                          return true;
                        }
                      }
                    }
                  );

                  return (
                    <div key={fieldGroupName} className={classes.fieldGroup}>
                      <h5
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(fieldGroupName)}
                      >
                        <Tooltip
                          title={
                            openGroups[fieldGroupName] ? "collapse" : "show"
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                openGroups[fieldGroupName] ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>

                        <span className={classes.headlineText}>
                          {get(
                            this.props.permissionsStructure[fieldGroupName],
                            "name"
                          )}
                        </span>
                      </h5>

                      <div
                        style={{
                          display: openGroups[fieldGroupName]
                            ? "block"
                            : "none",
                        }}
                      >
                        <p className={classes.fieldGroupCheckAll}>
                          <Checkbox
                            indeterminate={
                              !isCheckedAll && !isNotCheckedAll && true
                            }
                            onChange={this.onCheckAllChange(
                              fieldGroupName,
                              isCheckedAll
                            )}
                            checked={isCheckedAll}
                          >
                            <b>{this.props.i18n.t("Check all")}</b>
                          </Checkbox>
                        </p>

                        {get(
                          this.props.permissionsStructure[fieldGroupName],
                          "fields",
                          []
                        ).map((field) => {
                          let isCheckedFieldAll = true;
                          if (get(field, "permissions")) {
                            const value = this.props.form.getFieldValue(
                              get(field, "key")
                            );

                            if (
                              value &&
                              value.length !== field.permissions.length
                            ) {
                              isCheckedFieldAll = false;
                            }
                          }

                          if (get(field, "name") === "N/A") {
                            return <div/>
                          }

                          return (
                            <div key={get(field, "key")}>
                              {get(field, "permissions") ? (
                                <div>
                                  <div
                                    className={classes.permissionsSelectWrapper}
                                  >
                                    <label
                                      className={classes.permissionsSelectLabel}
                                    >
                                      <b>{get(field, "name")}</b>
                                      <br />
                                      {getFieldDecorator(get(field, "key"), {
                                        initialValue: get(
                                          field,
                                          "permissions",
                                          []
                                        )
                                          .map((o) => o.key)
                                          .filter((permission) =>
                                            this.props.permissions
                                              ? !!~this.props.permissions.indexOf(
                                                  +permission
                                                )
                                              : false
                                          ),
                                      })(
                                        <Select
                                          mode="tags"
                                          placeholder={this.props.i18n.t(
                                            "NamespaceSettingsRoleForm:Please select"
                                          )}
                                          style={{ width: "100%" }}
                                        >
                                          {get(field, "permissions").map(
                                            (permission) => (
                                              <Option
                                                key={permission.key}
                                                value={permission.key}
                                              >
                                                {permission.value}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      )}
                                    </label>
                                    <span
                                      className={classes.checkField}
                                      onClick={this.onCheckField(
                                        get(field, "key"),
                                        isCheckedFieldAll,
                                        get(field, "permissions")
                                      )}
                                    >
                                      {isCheckedFieldAll
                                        ? this.props.i18n.t(
                                            "NamespaceSettingsRoleForm:Clear all"
                                          )
                                        : this.props.i18n.t("Check all")}
                                    </span>
                                  </div>
                                  {get(field, "label.type") && (
                                    <Alert
                                      type={get(field, "label.type")}
                                      message={get(field, "label.message")}
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "20px",
                                      }}
                                    />
                                  )}
                                  <br />
                                </div>
                              ) : (
                                <div>
                                  <p>
                                    {getFieldDecorator(get(field, "key"), {
                                      initialValue: this.props.permissions
                                        ? !!~this.props.permissions.indexOf(
                                            +get(field, "key"),
                                            false
                                          )
                                        : false,
                                      valuePropName: "checked",
                                    })(
                                      <Checkbox
                                        disabled={!isEditable}
                                        onChange={this.onCheckChange}
                                      >
                                        {get(field, "name")}
                                      </Checkbox>
                                    )}
                                  </p>
                                  {get(field, "label.type") && getFieldValue(get(field, "key")) && (
                                    <Alert
                                      type={get(field, "label.type")}
                                      message={get(field, "label.message")}
                                      style={{
                                        marginTop: "-4px",
                                        marginBottom: "20px",
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                }
              )}
            </Col>
          </Row>

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
                {isLoading && <Icon type="loading" />}
              </Button>
            )}
            &nbsp; &nbsp;
            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
            &nbsp; &nbsp;
            {requestResult.type && (
              <Alert
                message={requestResult.message}
                type={requestResult.type}
                className={classes.submitResult}
              />
            )}
          </div>
        </Form>

        <Modal
          title={`Role ${
            this.state.roleState === "inactive"
              ? this.props.i18n.t("Activate")
              : this.props.i18n.t("Deactivate")
          }`}
          visible={deactivateSubmitModal}
          onOk={this.toggleActivate}
          onCancel={this.hideDeactivateModal}
        >
          <p>
            {this.props.i18n.t("NamespaceSettingsRoleForm:Confirm role")}{" "}
            {this.state.roleState === "inactive"
              ? this.props.i18n.t("activate")
              : this.props.i18n.t("deactivate")}{" "}
            {this.props.i18n.t("action")}
          </p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  roleCreatePermission: getRoleCreatePermission(state),
  roleUpdatePermission: getRoleUpdatePermission(state),
  roleDeletePermission: getRoleDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "site" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsRoleForm))
);



// WEBPACK FOOTER //
// ./src/components/SettingsRoleForm/SettingsRoleForm.js